
    <div class="Customers customer-company ui-g">
      <div class="ui-g ui-fluid" style="width: 100%">
        <div class="ui-g-12">
          <div>
            <div class="ui-g ui-g-nopad form-group master-data">
              <div class="ui-g-12 ui-lg-8 ui-g-nopad">
                <h1 class="step-title">{{ titlePage | translate}}</h1>
              </div>
              <div class="ui-g-12 ui-lg-4 text-right">
                <button
                  pButton
                  type="button"
                  class="k-generic-btn"
                  icon="fa fa-angle-left"
                  iconPos="left" label="Back"
                  (click)="locationBack()">
                </button>
                <button
                  pButton
                  type="button"
                  class="k-generic-btn"
                  icon="fa fa-floppy-o"
                  iconPos="left"
                  label="{{ 'common.save' | translate }}"
                  (click)="save()">
                </button>
              </div>
            </div>
          </div>
          <form *ngIf="formData" [formGroup]="formData">
            <div class="ui-g form-group master-data">
              <div [kv-form-element]="{ label: 'promotion.code', md: '4' }">
                <input
                  type="text"
                  pInputText
                  formControlName="code" />
              </div>
              <div [kv-form-element]="{ label: 'promotion.description', md: '4' }">
                <input
                  type="text"
                  pInputText
                  formControlName="description" />
              </div>
              <div [kv-form-element]="{ label: '', md: '1' }"></div>
              <div [kv-form-element]="{ label: 'promotion.graph', md: '2' }">
                <p-inputSwitch formControlName="flg_graph"></p-inputSwitch>
              </div>
              <div [kv-form-element]="{ label: '', md: '1' }"></div>
              <div [kv-form-element]="{ label: 'promotion.bmpPath', md: '6' }">
                <input
                  type="text"
                  pInputText
                  formControlName="bmp_path" />
              </div>
              <div [kv-form-element]="{ label: 'promotion.bmpRef', md: '6' }">
                <input
                  type="text"
                  pInputText
                  formControlName="bmp_ref" />
              </div>
              <div [kv-form-element]="{ label: 'promotion.barCode', md: '12' }">
                <input
                  type="text"
                  pInputText
                  formControlName="layout_barcode" />
              </div>
              <div [kv-form-element]="{ label: 'promotion.printType', md: '4' }">
                <p-dropdown
                  [options]="printTypes"
                  formControlName="layout_print_type_pid">
                </p-dropdown>
              </div>
              <div [kv-form-element]="{ label: 'promotion.tillType', md: '4' }">
                <p-dropdown
                  [options]="tillTypes"
                  formControlName="layout_till_type_pid">
                </p-dropdown>
              </div>
              <div [kv-form-element]="{ label: 'promotion.template', md: '4' }">
                <p-dropdown
                  [options]="templates"
                  formControlName="layout_template_pid">
                </p-dropdown>
              </div>
              <div [kv-form-element]="{label: 'promotion.otherFields', md: '12'}">
                <kv-promo-layout-detail-fields
                  [form]="formData"
                  [layoutDetailRowPositions]="layoutDetailRowPositions"
                  [details]="details"
                  (deleteElement)="deletePrivacyList($event)">
                </kv-promo-layout-detail-fields>
              </div>
              <button
                pButton
                type="button"
                class="k-generic-btn"
                icon="fa fa-plus-circle"
                label="{{'common.add' | translate}}"
                (click)="addPrivacy()">
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/views/promotion/layout/components/layoutDetail.component.ts.LayoutDetailComponent.html